const vLS09 = "[0-9]+";
const vLSAZ$ = "[A-Z $%*+\\-./:]+";
let vLSu3000u303Fu3040u309F = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
vLSu3000u303Fu3040u309F = vLSu3000u303Fu3040u309F.replace(/u/g, "\\u");
const v10219 = "(?:(?![A-Z0-9 $%*+\\-./:]|" + vLSu3000u303Fu3040u309F + ")(?:.|[\r\n]))+";
exports.KANJI = new RegExp(vLSu3000u303Fu3040u309F, "g");
exports.BYTE_KANJI = /[^A-Z0-9 $%*+\-./:]+/g;
exports.BYTE = new RegExp(v10219, "g");
exports.NUMERIC = /[0-9]+/g;
exports.ALPHANUMERIC = new RegExp(vLSAZ$, "g");
const v10220 = new RegExp("^" + vLSu3000u303Fu3040u309F + "$");
const v10221 = /^[0-9]+$/;
const v10222 = /^[A-Z0-9 $%*+\-./:]+$/;
exports.testKanji = function (p12833) {
  return v10220.test(p12833);
};
exports.testNumeric = function (p12834) {
  return v10221.test(p12834);
};
exports.testAlphanumeric = function (p12835) {
  return v10222.test(p12835);
};